import React from 'react';
import { Button } from '@material-ui/core';
import SwitchAccessShortcutAddIcon from '@mui/icons-material/SwitchAccessShortcutAdd';

import { white } from 'utils/color-styles';

interface Props {
  onClick: () => void;
}

export const MoveToAttendeeListButton = ({ onClick }: Props) => (
  <Button
    style={{ color: white, borderColor: white, height: 30 }}
    onClick={onClick}
    role="button"
    title="Move to attendee list"
    endIcon={<SwitchAccessShortcutAddIcon />}
  >
    Move to attendee list
  </Button>
);
